import React from 'react';
import { UserPlusIcon } from 'lucide-react';
export function MembershipSection() {
  return <div className="flex-1 rounded-2xl p-8 md:p-10 flex flex-col justify-between" style={{
    backgroundColor: '#c8a84b'
  }} data-id="element-1888">
      <div data-id="element-1889">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{
        backgroundColor: 'rgba(30,61,47,0.15)'
      }} data-id="element-1890">
          <UserPlusIcon size={24} style={{
          color: '#1e3d2f'
        }} data-id="element-1891" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold uppercase mb-3" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1a1a1a'
      }} data-id="element-1892">
          Join FLSC
        </h2>
        <p className="text-base leading-relaxed mb-6" style={{
        color: '#2a2a2a',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-1893">
          Become part of a community dedicated to safe, responsible shooting
          sports and outdoor recreation. Members enjoy 24/7 range access,
          discounted classes, and more.
        </p>
        <p className="text-sm font-medium mb-6" style={{
        color: '#2a2a2a',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-1894">
          Click below to fill out an Application for Membership.
        </p>
      </div>
      <a href="/Apply-For-Membership" className="inline-flex items-center justify-center gap-2 w-full py-4 rounded-lg font-bold text-base transition-all hover:opacity-90 active:scale-95" style={{
      backgroundColor: '#1e3d2f',
      color: '#ffffff',
      fontFamily: 'Inter, sans-serif'
    }} data-id="element-1895">
        <UserPlusIcon size={18} data-id="element-1896" />
        Click Here to Apply
      </a>
    </div>;
}